var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgHideResults = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 24,
    viewBox: "0 0 140 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #Path_2149.cls-1 {\n        fill: #ececec;\n      }\n\n      #HIDE_RESULTS.cls-2 {\n        fill: #373737;\n        font-size: 10px;\n        font-family: ArialMT, Arial;\n        letter-spacing: 0.2em;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_708",
    "data-name": "Group 708",
    transform: "translate(-916 -659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2149",
    "data-name": "Path 2149",
    className: "cls-1",
    d: "M12,0H128a12,12,0,0,1,0,24H12A12,12,0,0,1,12,0Z",
    transform: "translate(916 659)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Component_51_55",
    "data-name": "Component 51 \\u2013 55",
    transform: "translate(935 665.5)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "HIDE_RESULTS",
    "data-name": "HIDE RESULTS",
    className: "cls-2",
    transform: "translate(4 9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "HIDE RESULTS"))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHideResults, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/HideResults.ee361300.svg";
export { ForwardRef as ReactComponent };